export default "__VITE_ASSET__BG6cIR98__"